import { faEllipsisH, faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import { Button, DropdownButton, Icon } from '@seiue/ui'
import styled from 'styled-components'

import { blockTypeToLabel } from 'packages/feature-utils/test-paper'

import { BlockFooter } from '../../BlockFooter'
import { FooterComponent } from '../../BlockWrapper/types'

/**
 * Material 块选中态下的 Footer
 *
 * @param {FooterComponent} param0 - 参数对象
 * @returns Material 块选中态下的 Footer
 */
export const MaterialSelectedFooter: FooterComponent = ({
  blockData,
  onDuplicate,
  onDelete,
  onMoveUp,
  onMoveDown,
  canMoveUp,
  canMoveDown,
  key,
  canEdit,
}) => (
  <BlockFooter
    key={key}
    left={<FooterLabel>{blockTypeToLabel.get(blockData.type)}</FooterLabel>}
    right={
      <div>
        {canEdit ? (
          <Button
            size="xs"
            icon={faTrashAlt}
            type="text"
            onClick={async () => {
              await onDelete()
            }}
          >
            {'删除'}
          </Button>
        ) : null}
        <DropdownButton
          label={
            <Icon
              size={16}
              icon={faEllipsisH}
            />
          }
          trigger="click"
          labelButtonProps={{
            type: 'text',
            size: 'xs',
            style: {
              fontSize: '12px',
              lineHeight: '16px',
            },
          }}
          showArrow={false}
          items={[
            ...(canEdit
              ? [
                  {
                    label: '复制副本',
                    callback: () => onDuplicate?.({ range: 'block' }),
                  },
                ]
              : []),
            {
              label: '上移',
              callback: onMoveUp,
              disabled: !canMoveUp,
            },
            {
              label: '下移',
              callback: onMoveDown,
              disabled: !canMoveDown,
            },
          ]}
        />
      </div>
    }
  />
)

const FooterLabel = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.text._2};
`
